"use client";

import React, { useEffect, useState } from "react";

import PortfolioMain from "@/components/Portfolio/Superpositions/Main";
import useProtocolVaults from "@/hooks/api/useProtocolVaults";
import useProtocol from "@/hooks/api/useProtocol";

export default function ProtocolPositionsPage({ params: { slug } }: { params: { slug: string } }) {
  const [protocolId, setProtocolId] = useState<string | undefined>(undefined);

  // @ts-ignore
  const { data: name, isLoading: nameLoading } = useProtocol(slug);
  const { data: protocolVaults } = useProtocolVaults(protocolId, nameLoading);

  useEffect(() => {
    if (name && !nameLoading) {
      setProtocolId(name.id);
      return;
    }
  }, [name, nameLoading]);

  return (
    <section className="flex min-h-0 flex-1 flex-col items-stretch pt-6">
      <PortfolioMain isProtocol filterVaults={protocolVaults} hideColumns={["protocol"]} />;
    </section>
  );
}
